import { initialState } from './state'

const reset = (state) => {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
        state[key] = s[key]
    })
}

const setPages = (state, { pages }) => {
    state.pages = pages
}

const setCurrentPage = (state, { page }) => {
    state.currentPage = page
}

export default {
    reset,
    setPages,
    setCurrentPage
}
